<div class="price-discount-container">
  <div class="price-discount_prices">
    <p *ngIf="isSavedAmount" class="price-discount_prices__discounted-price" [style.font-size]="isCard ? '13px' : '14px'">{{currency}} {{originalPrice}}</p>
    <p class="price-discount_prices__original-price" [style.font-size]="isCard ? '16px' : '20px'">{{currency}} {{userPrice | number: "1.0-2" }}</p>
  </div>
  <div [style.font-size]="isCard ? '12px' : '14px'" *ngIf="isSavedAmount" class="price-discount_saved" matTooltip="{{getTooltipText()}}">
    {{getPriceSubtext()}}
  </div>
</div>
